import { CompositeChart } from '@mantine/charts'
import { SoldWoolSummary } from '@shared/components/wool-data/sold-wool-summary/types'
import '@mantine/charts/styles.css'

interface SoldWoolSummaryChartProps {
  data?: Array<SoldWoolSummary>
}

export const SoldWoolSummaryChart = ({ data = [] }: SoldWoolSummaryChartProps) => {
  return (
    <CompositeChart
      h={300}
      data={data}
      data-testid='sold-wool-summary-chart'
      aria-hidden='true' // Hide chart from screen readers, they can read the table instead
      dataKey='season'
      maxBarWidth={40}
      curveType='bump'
      yAxisProps={{
        tickFormatter: (value: number) => `$${Intl.NumberFormat().format(value / 1000)}k`,
      }}
      withRightYAxis
      rightYAxisProps={{
        unit: ' bales',
      }}
      valueFormatter={(value) => new Intl.NumberFormat('en-US').format(value)}
      tooltipAnimationDuration={100}
      withLegend
      legendProps={{ verticalAlign: 'bottom', height: 50 }}
      series={[
        {
          name: 'totalNetProceedsIncGST',
          label: 'Total Proceeds',
          color: 'rgba(18, 120, 255, 0.4)',
          type: 'bar',
        },
        {
          name: 'totalBales',
          label: 'Total Bales',
          color: 'orange',
          type: 'line',
          yAxisId: 'right',
        },
      ]}
    />
  )
}
